import React from 'react';
import { Link } from '@ha/dsl';

function Terms() {
  return (
    <ul>
      <li>
        A refund will not be given in other circumstances which include, but are
        not limited to: accommodation that is not according to taste;
        accommodation that is not in line with religious ideology (including
        living with people from another sex); accommodation that is not clean,
        accommodation that turns out to be in a less safe neighbourhood;
        accommodation that has noise complaints; accommodation is not suitable
        to the tenant because of medical reasons; accommodation has a minor
        malfunction that could not have been known in advance; the tenant is
        hindered in coming to the accommodation because of a change of plans,
        travel delays, illness or having made a double booking; the tenant fails
        to report the issue within the first 48 hours after the move-in date
        registered on the platform.
      </li>
      <li>
        <p>
          General Terms and Conditions (GTC) for using the short-term housing
          platform on{' '}
          <Link to="https://housinganywhere.com" kind="mint-underline">
            housinganywhere.com
          </Link>
        </p>
        <p>
          <i>(Last updated version: 6 February 2019)</i>
        </p>
        <h4>Article 1: Scope, amendment of General Terms and Conditions</h4>
        <ol>
          <li>
            The General Terms and Conditions (GTC) below apply to the use of the
            platform www.housinganywhere.com (also: “platform”). This is a
            service of Housing Anywhere BV (“Housing Anywhere” or “we”).
          </li>
          <li>
            “Users” within the sense of these General Terms and Conditions are
            natural and legal persons who have either posted an advertisement of
            an accommodation on the platform or responded to an advertisement of
            an accommodation.
          </li>
          <li>
            Customers of Housing Anywhere are educational institutions. They
            subscribe to a membership on the platform in order to offer this
            platform as a housing option to their students.
          </li>
          <li>
            Housing Anywhere offers the usage of its platform, in particular the
            use of the database, solely on the basis of these General Terms and
            Conditions.
          </li>
          <li>
            By using our services, users consent to the validity of these
            General Terms and Conditions.
          </li>
          <li>
            By using our services, users confirm that they oblige the national
            laws and obligations of their country with respect to renting and
            subletting.
          </li>
          <li>
            Housing Anywhere reserves the right to amend its General Terms and
            Conditions effective for the future. The amendments will not become
            part of the agreement until the user consents to such amendments. It
            is sufficient for this purpose that Housing Anywhere sends the new
            version of the General Terms and Conditions to the e-mail address
            that the user provided for information purposes. If the user does
            not contradict the amendments to the General Terms and Conditions
            within one week, consent will be considered to have been granted.
          </li>
          <li>
            Conflicting terms and conditions of the user have no effect (point
            2.5 notwithstanding), even if Housing Anywhere does not contradict
            them.
          </li>
        </ol>
        <h4>
          Article 2: Performance by Housing Anywhere, performance by providers
        </h4>
        <ol>
          <li>
            The platform is an online market place on which users can offer and
            rent rooms or other types of accommodation (“accommodation”).
          </li>
          <li>
            On www.Housing Anywhere, Housing Anywhere provides a platform on
            which users can find ways to communicate with each other and
            conclude agreements. Housing Anywhere itself does not offer any
            accommodation; it merely acts as an intermediary for the conclusion
            of agreements between users.
          </li>
          <li>
            Housing Anywhere emphasizes that the use of a lease contract between
            provider and tenant is highly recommended. Based on the importance
            that Housing Anywhere puts on the use of a lease, she offers
            provider and tenant a predrafted lease contract. By offering an
            accommodation on Housing Anywhere provider agrees with the
            application of Housing Anywhere’s predrafted lease contract, unless
            provider explicitly declares that a different lease contract is
            applicable and tenant agrees with this different lease contract.
            Housing Anywhere only offers the predrafted lease contract by means
            of a favor to users. The applicability of the lease contract remains
            an own choice of tenant and provider. Housing Anywhere can therefore
            never be held responsible for any shortcomings in the predrafted
            lease contract, or any damages following from the use of the
            predrafted lease contract.
          </li>
          <li>
            Leases are concluded exclusively between the user providing the
            accommodation (“provider”) and the user renting the accommodation
            (“tenant”). Housing Anywhere itself is not a party to the leases
            concluded between the website’s users. However, Housing Anywhere is
            entitled to act as a representative for the provider with the
            authority to conclude agreements and to conclude agreements on
            his/her behalf. However, the provider and the tenants are themselves
            responsible for satisfying their own contractual obligations. In the
            event of default, this must be negotiated between the users. Housing
            Anywhere saves and will transmit the contact data of both parties
            for this purpose.
          </li>
          <li>
            Housing Anywhere does not examine the legality, accuracy or
            completeness of offers published on the platform or user content,
            and these do not represent the views of Housing Anywhere. Housing
            Anywhere is not responsible for third-party offerings or content.
          </li>
          <li>
            Providers can apply their own terms and conditions to the
            accommodation they are renting that do not affect the General Terms
            and Conditions of Housing Anywhere.
          </li>
          <li>
            Providers and tenants are responsible for their adherence to the
            provisions governed by public law, including municipal codes
            regarding property rental.
          </li>
          <li>
            Providers are responsible for the permission of their landlord in
            the case of sublease.
          </li>
          <li>
            Providers are responsible for the arrangement of all required
            documents to rent out the apartment. These documents include, but
            are not limited to, licenses to (sub)rent from the landlord or
            municipality, (sub)rental contracts.
          </li>
          <li>
            By agreeing to these General Terms and Conditions (GTC), provider
            states that he/she has permission by the landlord (private, agent or
            housing cooperation) to rent out the room/property, as depicted
            under 8; has arranged all required documents, as depicted under 9;
            and has, if applicable, informed his/her roommates.
          </li>
        </ol>
        <h4>
          Article 3: Registration, realisation of the user agreement,
          contractual declarations
        </h4>
        <ol>
          <li>
            The registration of users is required in order to make use of
            Housing Anywhere. Providers register when putting their room online.
            Tenants register when replying to a room. Registration is free of
            charge and requires that users accept Housing Anywhere’s General
            Terms and Conditions. The user agreement between Housing Anywhere
            and the user arises on acceptance of the terms and conditions.
          </li>
          <li>
            Registration is available only to natural persons, legal persons and
            partnerships that are fully legally competent. The registration of a
            legal person or partnership may be performed only by a natural
            person with power of representation who must be named. When
            registering, only individual persons may be given as the owner of
            the user account (i.e. no married couples or families).
          </li>
          <li>
            Registration as a provider is available only to people with an
            activated student email-account, people in possession of a
            coupon/code provided by Housing Anywhere or an activated landlord
            account.
          </li>
          <li>
            When registering, the user undertakes to provide accurate,
            up-to-date and complete information as required by the registration
            form, in particular first and last name, current address (not a PO
            box), a valid e-mail address and, where appropriate, the name of the
            company and an authorised representative. The data must be
            up-to-date and correct at all times. Multiple registrations under
            different member names are prohibited. When registering, the user
            chooses a password to accompany his/her email address.
          </li>
          <li>
            The user can receive contractual declarations at his/her stated
            e-mail address.
          </li>
        </ol>
        <h4>Article 4: User obligations, user account, system integrity</h4>
        <ol>
          <li>
            The user is solely responsible for all content that he places on the
            platform. In his/her relationship to HousingAnywhere.com, he commits
            not to place illegal content on the platform and to refrain from
            actions that violate laws.
          </li>
          <li>
            The provider is responsible for ensuring that the accommodation he
            offers is described correctly and completely. He must provide the
            information in HousingAnywhere.com’s required fields at a minimum so
            that the accommodation and the offer are described with sufficient
            accuracy.
          </li>
          <li>
            The user agrees that all the photos added must be authentic and show
            a realistic sight of the rooms. Pictures replications from other
            websites will be, without prior notice, deleted and the user will be
            removed or disabled from the platform.
          </li>
          <li>
            In addition, the provider is free to stipulate further conditions
            such as the amount of any deposit, the cost of final cleaning, etc.
            The user undertakes to keep the information in his/her user account
            up-to-date and accurate at all times, i.e. to correct it immediately
            in the event of a change or delete the room from the platform in
            case tenant and provider have agreed on rental. A user account is
            personal and can therefore not be transferred to any other person.
          </li>
          <li>
            The user undertakes to use his/her user account himself only and to
            keep his/her password secret.
          </li>
          <li>
            The user is liable to HousingAnywhere.com for all actions performed
            using his/her user account, unless the user is not responsible for
            the misuse of his/her user account.
          </li>
          <li>
            Once the user is aware that third parties have access to his/her
            user data or have otherwise gained access to his/her user account,
            he must notify HousingAnywhere.com of this immediately.
            HousingAnywhere.com is entitled to block the user account until the
            situation has been clarified.
          </li>
          <li>
            HousingAnywhere.com, without prior notice, will charge the price of
            the booking fee and remove or disable access of the User who posts,
            sends, publishes, or transmits any kind of personal contact that
            would lead the other party outside the platform. (E.g. Personal bank
            account, phone number, email, etc).
          </li>
          <li>
            Each user must independently verify the identity of his/her
            respective contract partner (the tenant in case of the provider or
            the provider in case of the tenant). HousingAnywhere.com accepts no
            liability for the accuracy of the user contact information entered
            on the platform.
          </li>
          <li>
            The user undertakes to set up his/her systems and programs in
            connection with the use of HousingAnywhere.com offering in a way
            that ensures that the security, integrity and availability of
            systems set up by HousingAnywhere.com to provide its services are
            not affected. Users must not block, rewrite, or modify content
            generated by HousingAnywhere.com or interfere in any other way that
            contravenes the purpose of the user agreement. HousingAnywhere.com
            is entitled to set up the required measures in accordance with item
            15 as are necessary to ensure the system integrity of all the
            parties.
          </li>
          <li>
            Users must not use addresses, contact data, or e-mail addresses that
            they obtain by using the website for any purpose other than for
            contractual communication. In particular, these data must not be
            forwarded to unauthorised persons or used to send advertising,
            unless the user in question has expressly granted his/her consent in
            advance.
          </li>
          <li>
            The user must not send mass messages with the same content via the
            platform. Any spamming or similarly harassing action towards other
            users or third parties is prohibited.
          </li>
          <li>
            Each user is himself responsible for archiving any information that
            can be viewed on the website and saved by HousingAnywhere.com that
            is required for the purposes of preservation of evidence,
            accounting, etc. on a storage medium independent of
            HousingAnywhere.com.
          </li>
          <li>
            HousingAnywhere.com does not give away any contact details of its
            users to any third party, except to our partner institutions, or if
            the law requires to do so. The partner institutions (mostly
            universities or other educational institutions) can ask
            HousingAnywhere.com for an overview of rooms rented out in the city
            of their settlement. The purpose of this information sharing is so
            that the partner institutions can forecast the room demand in their
            city in a better way and check possible student misuses.
          </li>
          <li>
            In the event of a violation of these General Terms and Conditions by
            a user, HousingAnywhere.com is entitled to exercise its virtual
            householder rights. HousingAnywhere.com can exclude the user in
            question from using its services, delete the content he uses, or
            take other measures within the meaning of item 13.
            HousingAnywhere.com will take legal action to exercise its
            legitimate rights to forbearance and compensation.
          </li>
        </ol>
        <h4>Article 5: Handling of content and rights</h4>
        <ol>
          <li>
            Within the framework of the platform’s functionality, providers can
            present to potential tenants using a variety of media. Certain rules
            must be complied with to ensure that the various media are utilised
            legally so that neither the user nor Housing Anywhere can be made
            liable. These rules derive, for example, from laws protecting
            copyrights and brands in addition to these General Terms and
            Conditions.
          </li>
          <li>
            Housing Anywhere saves for the user the multimedia content uploaded
            by him (images, text, etc.) or merely arranges the necessary memory
            space and access to it. Users themselves are solely responsible for
            the content they upload to Housing Anywhere and indemnify Housing
            Anywhere against all third-party claims resulting from this. In
            particular, this indemnification also includes the costs of
            appropriate prosecution and legal defence.
          </li>
          <li>
            Users will ensure that the uploaded content does not violate
            applicable law or legal provisions, common decency, or in particular
            third-party rights (naming rights, personality rights, copyright,
            data protection rights, etc.). In particular, users undertake not to
            upload content that violates the terms of any applicable laws or
            treaties. The user also undertakes not to utilise content that is
            pornographic, glorifies violence, or is race baiting. This also
            applies to the sending of e-mails and other electronic communication
            media of the platform.
          </li>
          <li>
            By uploading multimedia content, users transfer to Housing Anywhere
            a free, revocable, unlimited, non-local right of use that can be
            sub-licensed to the multimedia content uploaded to Housing Anywhere
            by the user. In particular, the right of use comprises the right to
            process the multimedia content for the purposes of the platform and
            to make it available to the public offline, in printed or electronic
            form, by wired or wireless connection, in such a way that it is
            accessible to members of the public at places and times of their
            choosing, including playback on their chosen receiver terminal that
            allows online access, in particular stationary and portable computer
            and mobile handheld devices such as smartphones, tablets and similar
            equipment. The usage rights also include the right to integrate
            multimedia content, including advertising media, on websites from
            Housing Anywhere’s contractual partners.
          </li>
          <li>
            Housing Anywhere is free to use any comments, information, pictures
            or ideas contained in any communication user may send to Housing
            Anywhere without compensation, acknowledgement or payment to user
            for any purpose whatsoever, including, but not limited to,
            developing, manufacturing and marketing products and services and
            creating, modifying or improving the services or website or other
            products or services. For the avoidance of doubt, all such
            information will be deemed by Housing Anywhere to be
            non-confidential and non-proprietary, and user agrees that such
            information may be used by Housing Anywhere without any limitation
            whatsoever.
          </li>
          <li>
            User explicitly agrees that Housing Anywhere is free to read any
            messages sent between users. Housing Anywhere may read these
            messages to improve user experience, solve conflicts between users
            or for other reasons Housing Anywhere deems appropriate.
          </li>
          <li>
            User agrees that Housing Anywhere is free to republish and make use
            of any information published by you on the website without
            acknowledging user as the source of such information and/or creator
            of such content. In general however, Housing Anywhere will make an
            attempt to provide a link back to user&apos;s page when posting
            content on other third party sites, such as Facebook or any of our
            contractual partners. User hereby irrevocably waives all moral
            rights to any content placed on the website.
          </li>
          <li>
            User explicitly allows Housing Anywhere to use and show user&apos;s
            (Facebook)profile picture on its website www.housinganywhere.com.
          </li>
          <li>
            The content offered via Housing Anywhere is protected by copyright.
            The platform is generally accessed and utilised individually by a
            natural person using a web browser. The use of technologies such as
            web spiders, crawlers, or similar programmes, the purpose of which
            is not just the indexing of content but also the mass accessing and
            saving of the platform’s content is prohibited. This also applies in
            particular to technologies that enable so-called screen scraping and
            other third-party services.
          </li>
          <li>
            In the event of a violation of these prohibitions and the guidelines
            of these General Terms and Conditions, Housing Anywhere is entitled
            to refuse acceptance of content, to delete and block content
            immediately and to delete the pages and links to them immediately.
            In such cases the user has no right to the restoration of his/her
            multimedia content on the internet platform or the release of
            his/her deleted user profile.
          </li>
        </ol>
        <h4>Article 6: Availability and amendment of the website</h4>
        <ol>
          <li>
            The user has no legal claim to permanent use of the platform. In
            particular, Housing Anywhere is not required to ensure that the
            platform is available or can be reached at all times. However,
            Housing Anywhere endeavours to maintain operation of the platform
            with as few disruptions as possible and to continue to develop it in
            line with user requirements.
          </li>
          <li>
            Housing Anywhere can temporarily restrict use if this is necessary
            in terms of security, integrity, capacity limits, or the performance
            of technical measures (maintenance work). In particular, Housing
            Anywhere will take users’ legitimate interests into account by
            notifying them in advance.
          </li>
        </ol>
        <h4>Article 7: Liability for third-party sites</h4>
        <ol>
          <li>
            The platform’s pages also include links to websites on the Internet
            maintained by third parties, the content of which is not known to
            Housing Anywhere. Housing Anywhere merely provides access to the
            websites and accepts no responsibility for the content. The links to
            third-party Internet sites merely serve to facilitate navigation.
            Housing Anywhere does not espouse the views expressed on the sites
            to which it links, and rather hereby expressly distances itself from
            all content on all websites that it links to on its platform.
          </li>
          <li>
            The owners of the Internet sites to which the Housing Anywhere
            platform hyperlinks are solely responsible for both their content
            and the goods or services offered for sale there.
          </li>
        </ol>
        <h4>
          Article 8: Secure booking service, payment, invoice and commission
        </h4>
        <ol>
          <li>
            By listing an accommodation on the HousingAnywhere.com website, the
            provider is issuing an invitation to submit offers. Another user can
            submit an offer to conclude a lease for this accommodation. The
            agreement arises if the provider accepts this offer, unless the
            tenant withdraws this offer before the provider accepts it.
          </li>
          <li>
            A lease is the period for which the tenant leases the accommodation
            from the provider. The length of a lease can differ with no maximum
            nor minimum. The average length of a lease will be around 5 months.
          </li>
          <li>
            After conclusion of the agreement, HousingAnywhere.com provides
            tenants with a booking method via the website of
            HousingAnywhere.com, where HousingAnywhere.com keeps possession of
            the money until 48 hours after the start of the lease. After this
            period HousingAnywhere.com will transfer the payment of the lease to
            the provider. HousingAnywhere.com acts as a third party custodian in
            order to eliminate scams.
          </li>
          <li>
            The use of the secure booking service, offered by
            HousingAnywhere.com, is mandatory for all website users. The
            provider of the accommodation is responsible for the execution of
            the payment of the first month rent via HousingAnywhere.com.
          </li>
          <li>
            In the case an agreement has been made and parties continue with the
            payment procedure the tenant will receive a payment link from
            HousingAnywhere.com, through which the payment is transferred to
            HousingAnywhere.com. The payment will be transferred to a secure,
            third-party bank account. After 48 hours from the move-in date
            registered on the platform and if the tenant does not request
            changes, HousingAnywhere.com will order the rent to be transferred
            to the provider and the processing fee to HousingAnywhere.com.
          </li>
          <li>
            Cancellation policy:
            <ol>
              <li>
                HousingAnywhere.com has a strict cancellation policy after a
                booking has been confirmed. Once there has been an agreement,
                the tenant is obligated to pay the amount due. In the case that
                the tenant decides not to make use of the accommodation after an
                agreement has been made there will be no refund unless there are
                eligible grounds for a refund as mentioned in Article 8.7 of our
                Terms & Conditions.
              </li>
              <li>
                If the tenant does not show up or does not take the
                accommodation, then HousingAnywhere.com will transfer the first
                month rent to the advertiser, to compensate the advertiser for
                the loss of an empty room. The secure booking fee will not be
                transferred, HousingAnywhere.com takes this as compensation for
                their services.
              </li>
              <li>
                HousingAnywhere.com transfers the rent to the advertiser, 48
                hours after the start of the rental contract registered in the
                platform.
              </li>
              <li>
                HousingAnywhere.com is no longer involved in executing the
                agreement made between the tenant and the advertiser when the 48
                hours have passed. In the same way, it is not possible to
                provide a refund after this 48 hours have passed and the tenant
                have not reported an issue with the room.
              </li>
              <li>
                If the tenant decides not take the accommodation after the
                booking occurred, the tenant always has the possibility of
                asking the advertiser if s/he is willing to refund the first
                month rent. This is up to the advertiser to agree on or not. If
                the advertiser agrees on refunding the first month rent, the
                advertiser should inform HousingAnywhere.com. If
                HousingAnywhere.com has already transferred the money to the
                advertiser then the advertiser must refund the money directly to
                the tenant. HousingAnywhere.com is not involved in the transfer
                of funds between the landlord and the tenant.
              </li>
            </ol>
          </li>
          <li>
            Refund policy:
            <ol>
              <li>
                Housing Anywhere will provide tenant with a refund of the first
                month rent and secure booking fee if:
                <ul>
                  <li>
                    A tenant discovers that he has been involved in the unlikely
                    case of a scam (the room does not exist at all, the room is
                    different than stated in the contract)
                  </li>
                  <li>
                    Is not available for the tenant’s use for the agreed lease
                    (for example, there is already someone else in the room)
                  </li>
                  <li>
                    Natural disasters (avalanches, snowstorms, cyclones,
                    hurricanes, earthquakes, flooding, lightning strikes,
                    landslides) or other unforeseeable events (war, terrorist
                    attack, nuclear disaster)
                  </li>
                </ul>
                This has to be informed to HousingAnywhere.com before the 48
                hours after the move-in date registered on the platform.
              </li>
              <li>
                A refund will not be given in other circumstances which include,
                but are not limited to: accommodation that is not according to
                taste; accommodation that is not in line with religious ideology
                (including living with people from another sex); accommodation
                that turns out to be in a less safe neighborhood; accommodation
                that has noise complaints; accommodation is not suitable to the
                tenant because of medical reasons; accommodation has a minor
                malfunction that could not have been known in advance; the
                tenant is hindered in coming to the accommodation because of a
                change of plans, travel delays, illness or having made a double
                booking.
              </li>
              <li>
                The tenant has the obligation to inform HousingAnywhere.com and
                the provider within 48 hours after the start of the lease period
                registered on the platform. The tenant must substantiate his
                claim and provide visual proof (pictures, videos). If
                HousingAnywhere.com finds, at its own discretion, the tenant’s
                claim to be convincing, it will refund the rent and the booking
                fee charged by HousingAnywhere.com to the tenant. If the tenant
                does not inform HousingAnywhere.com about any problems within 48
                hours from the start of the lease onwards, the tenant is
                expected to have agreed with the room as it is.
                HousingAnywhere.com will then transfer the payment of the rent
                to the provider.
              </li>
              <li>
                In the case of a dispute between tenant and provider
                HousingAnywhere.com advises parties to solve it themselves. If
                this turns out to be impossible, parties can provide
                HousingAnywhere.com with the information and possible proof of
                the dispute. After taking all the provided information into
                consideration, HousingAnywhere.com decides about the dispute
                which will be binding for both parties.
              </li>
              <li>
                The room must be delivered to the tenant in a clean state. If
                the tenant arrives and the room is not in a suitably hygienic
                state to live in, the advertiser risks the payment being put on
                hold and potentially canceled until the advertiser resolves the
                problem. The tenant must provide evidence of these unsuitable
                conditions (i.e. photo). HousingAnywhere.com will decide if this
                is significant enough to delay and/or cancel the payment.
              </li>
            </ol>
          </li>
          <li>
            The provider must ensure that:
            <ol>
              <li>
                A correct IBAN/BIC bank account is provided. HousingAnywhere.com
                will transfer the rent to the bank account provided and is not
                liable if this bank account is not correct.
                HousingAnywhere.com’s obligations towards provider will cease to
                exist once HousingAnywhere.com has transferred the rent to the
                bank account provided by provider. Whether this bank account is
                correct or not is to remain the risk of the provider and does
                not stand in the way of releasing HousingAnywhere.com from its
                liabilities.
              </li>
              <li>
                the description of the accommodation and the images used do not
                violate the law or third-party rights and that they relate only
                to the accommodation on offer;
              </li>
              <li>
                successfully booked accommodation is indicated accordingly or
                removed from the platform;
              </li>
              <li>
                information uploaded does not constitute references to
                third-party content;
              </li>
              <li>
                he complies with public law regulations, particularly those for
                payment, factoring and tax law obligations, which may also
                include any obligations under sales tax law or indirect tax
                obligations. The provider will be solely responsible of the
                obligations and duties of the offer content. HousingAnywhere.com
                is entitled to verify the offer of the users and ask for the
                corresponding proofs;
              </li>
              <li>
                once a tenant has requested renting the accommodation, provider
                is not allowed to request a higher price than requested in the
                original advertisement.
              </li>
            </ol>
          </li>
          <li>
            With respect to offers provided by user:
            <ol>
              <li>
                Anyone who is interested in renting an accommodation posted on
                the platform can react via the platform.
              </li>
              <li>
                The purpose of reacting to an accommodation can only be related
                to the wish of coming to an agreement concerning the leasing of
                an accommodation posted on www.housinganywhere.com. All other
                purposes that are not in accordance with this goal, such as, but
                not limited to, contacting the provider for any advertising
                purposes, asking users to post their room offers on different
                housing websites, generating flow to any other websites, use any
                automatic or manual process to search or harvest information
                from the website, or to interfere in any way with the proper
                functioning of the website are prohibited.
              </li>
              <li>
                Users are prohibited from circumventing the above booking and
                payment processes, in particular the processing fees.
              </li>
              <li>
                If reactions are made with a different reason than solely coming
                to an agreement on renting a property listed on
                www.housinganywhere.com and with that in breach of the previous
                paragraph, the replier is liable to a fine of €1000 (say: one
                thousand euros) per reaction sent.
              </li>
            </ol>
          </li>
          <li>
            The payment process shall take place under the following provisions:
            <ol>
              <li>
                The agreement arises by way of a total price shown at the end of
                the booking. This consists of the rent and the processing fee
                (certain percentage over the first month’s rent which is
                indicated next to the room price), which comprises an
                administration component and a property-based component
                determined by the rent. After a booking has been made,
                HousingAnywhere.com notifies users of its content and the total
                price.
              </li>
              <li>
                HousingAnywhere.com remains the right to offer its services to
                tenant for consecutive months. HousingAnywhere.com’s service is
                not just limited to the first month rent.
              </li>
              <li>
                HousingAnywhere.com is entitled to change the amount of
                processing fees at any time. This does not apply to leases
                already concluded. The provider will be notified of the amount
                of the processing fee by email in a timely manner, together with
                the booking inquiry.
              </li>
              <li>
                HousingAnywhere.com is entitled to change its business model in
                such a way that it will also collect a processing fee from the
                provider. This will show in a reduction on the rent transferred
                by HousingAnywhere.com to the provider.
              </li>
              <li>
                The tenant must pay the total price shown in the booking, by way
                of the channel chosen in the booking process.
                HousingAnywhere.com only receives the processing fee, the rent
                is transferred to the provider at a specified date of which
                details can be read under 8.3. If debt collection is
                unsuccessful, the tenant must reimburse any additional costs
                incurred. This does not apply if the tenant is not responsible
                for the failure of debt collection.
              </li>
              <li>
                HousingAnywhere.com charges the provider a Commission. The
                commission calculation can be found under Article 8.19.
              </li>
              <li>
                Users can offset HousingAnywhere.com processing fees against
                receivables only if these are due and have been legally
                established or are undisputed. Receivables cannot be transferred
                to third parties.
              </li>
              <li>
                HousingAnywhere.com makes use of a payment service provider. In
                the case of different currencies this payment service provider
                determines the exchange rate based on the market rate.
                HousingAnywhere.com has no role whatsoever in the determination
                of the exchange rate. In the case of a refund, the daily
                exchange rate will be used - regardless if the exchange rate was
                different when the payment was made. Moreover, in refund cases,
                the tenant is liable for his/her own bank&apos;s transaction
                costs, as well as any currency conversion service that his/her
                bank may provide.
              </li>
            </ol>
          </li>
          <li>
            On request, the provider must issue the tenant with an invoice for
            the total price. On request, HousingAnywhere.com will issue the
            provider with an invoice for the processing fee, though this will be
            shown without sales tax or similar indirect taxes in accordance with
            tax law provisions, unless expressly stated otherwise in these
            regulations.
          </li>
          <li>
            Unless HousingAnywhere.com is notified otherwise, it is refutably
            assumed that the provider operates in a business capacity and is
            aware of his/her resulting (sales) tax obligations and satisfies
            these accordingly. HousingAnywhere.com is entitled to demand
            corresponding evidence of the provider’s business capacity.
          </li>
          <li>
            The provider reserves the right to additionally charge other on-site
            costs based on consumption and use (in particular: electricity,
            water, heating). The provider must advise the tenant that he has a
            basic right to charge these costs before concluding the agreement.
            Such costs are not considered in the calculation of the booking fee.
          </li>
          <li>
            HousingAnywhere.com advises users that have agreed on renting an
            accommodation to sign a contract between the two of them.
          </li>
          <li>
            As mentioned on Article 8.10, a commission is charged for every
            booking. The commission is previously agreed between the Provider
            and HousingAnywhere.com represented by one of the Account Manager or
            determined during the sign-up process.
          </li>
          <li>
            The commission will be withheld from the payout of the first month
            rent.
          </li>
          <li>
            The commission is calculated based on the total contract value or as
            25% of the first month’s rent, depending on the plan. Total contract
            value is determined by the whole quantity of <u>days</u> of the
            booking. (e.g. from the 01/08/2017 to 31/12/2017 - that makes 153
            days)
          </li>
          <li>
            VAT (Value Added Tax) is NOT included in the rent price and is,
            therefore, calculated on top.
          </li>
          <li>
            As an example of commission based on total contract value:
            <br />
            <br />
            <table>
              <tbody>
                <tr>
                  <td>Contract value of a full year</td>
                  <td>=</td>
                  <td>Monthly rent</td>
                  <td>x</td>
                  <td>12 months</td>
                </tr>
                <tr>
                  <td>Contract value of a day</td>
                  <td>=</td>
                  <td>Contract value of a full year</td>
                  <td>/</td>
                  <td>365</td>
                </tr>
                <tr>
                  <td>Contract value of the booking</td>
                  <td>=</td>
                  <td>Contract value of a day</td>
                  <td>x</td>
                  <td>Length of Stay/Booking</td>
                </tr>
                <tr>
                  <td>Commission fee</td>
                  <td>=</td>
                  <td>Contract value of booking</td>
                  <td>x</td>
                  <td>Commission %</td>
                </tr>
                <tr>
                  <td>
                    <strong>Total due amount on the invoice</strong>
                  </td>
                  <td>
                    <strong>=</strong>
                  </td>
                  <td>
                    <strong>Commission Fee</strong>
                  </td>
                  <td>
                    <strong>+</strong>
                  </td>
                  <td>
                    <strong>VAT</strong>
                  </td>
                </tr>
              </tbody>
            </table>
            <br />
            As an example of commission based on 25% of first month’s rent:
            <br />
            Commission = 0.25x Monthly rent
            <br />
            Total due amount on the invoice = Commission + VAT
          </li>
        </ol>
        <h4>Article 9: Security deposit</h4>
        <ol>
          <li>
            The provider is entitled to charge a security deposit in his/her
            offer. If a provider demands a security deposit from the tenant on
            the day of arrival, corresponding information on the amount of the
            security deposit and the payment method must have already been
            mentioned in the offer. The amount of the security deposit must be
            stipulated prior to the booking. It must also be clarified in
            advance when the amount must be paid (e.g. upon moving in).
          </li>
          <li>
            If the provider did not mention the security deposit when
            advertising his/her accommodation, but demands a security deposit at
            a later time and the tenant does not agree, this constitutes a
            refusal to render performance by the provider under the agreed
            contract. In such cases, the tenant reserves the right to cancel the
            booking after which the provider is obligated to refund the tenant.
          </li>
          <li>
            Housing Anywhere is not responsible for the administration of
            security deposits, or for any claims asserted by the provider.
          </li>
          <li>
            The provider will be responsible for refunding the security deposit
            to the tenant at the end of the lease.
          </li>
        </ol>
        <h4>Article 10: Duration, termination</h4>
        <ol>
          <li>The user agreement is concluded for an indefinite period.</li>
          <li>
            The user can terminate the agreement at any time without notice.
            User&#8217;s leases with other users that have already been proven
            or arranged remain unaffected by the termination of the user
            agreement. This applies accordingly to claims for the payment of
            processing fees already due.
          </li>
          <li>
            Housing Anywhere can terminate the user agreement at any time with
            two weeks’ notice. An email will be sufficient for the purpose.
          </li>
          <li>
            This does not affect the right to block, the right to terminate for
            just cause or individually agreed rights of termination of the user.
            In particular, Housing Anywhere has just cause if:
            <ul>
              <li>
                The user does not comply with a not merely insignificant payment
                obligation in full or in part, despite having been sent a
                reminder with an appropriate deadline;
              </li>
              <li>
                The user violates his/her obligations under these General Terms
                and Conditions and does not take remedial action despite having
                been sent a reminder with a timely deadline. A reminder is not
                needed if this is not expected to be successful or if the breach
                is sufficiently severe that it would be unreasonable for Housing
                Anywhere to maintain the agreement.
              </li>
              <li>
                Requirements of law, a court, or an official authority mean that
                the use of the platform can no longer be offered in this form;
              </li>
              <li>
                Housing Anywhere discontinues its platform or business
                activities;
              </li>
              <li>
                Insolvency proceedings are initiated for the user’s assets owing
                to a lack of funds.
              </li>
            </ul>
          </li>
        </ol>
        <h4>
          Article 11: Measures in the event of illegal conduct and/or conduct in
          breach of agreement by the user
        </h4>
        <ol>
          <li>
            If there are specific indications that a user is culpably violating
            legal provisions, third-party rights, or the General Terms and
            Conditions or if Housing Anywhere otherwise has a legitimate
            interest, particularly with regard to protecting its users against
            fraudulent activities, Housing Anywhere can take one or more of the
            following actions subject to termination without notice:
            <ul>
              <li>Issue the user with a warning;</li>
              <li>Delete the user&#8217;s offers or other content;</li>
              <li>Restrict the user&#8217;s use of the website;</li>
              <li>
                Temporarily or permanently exclude (block) the user from the
                website;
              </li>
              <li>
                Contest and cancel existing leases in the name of the provider
                without taking into account any otherwise applicable
                cancellation policies, and reject the user’s offers for the
                conclusion of a lease in the name of the provider.
              </li>
            </ul>
          </li>
          <li>
            Housing Anywhere also takes the legitimate interests of the user in
            question into consideration when choosing these measures.
          </li>
          <li>
            Leases that have already been concluded between the user and other
            users are not affected by deletion of an offer. This applies
            accordingly to claims for the payment of processing fees already
            due. An effective lease does not arise if Housing Anywhere deletes
            an offer before it is accepted.
          </li>
          <li>
            Housing Anywhere has the right to permanently block a user in each
            of the following cases. As far as reasonable, the user will receive
            prior warning by Housing Anywhere so that it has the opportunity to
            dispel suspicion or take remedial action. If a previous warning is
            not reasonable, e.g. because blocking is necessary to prevent any
            damage to Housing Anywhere or another user, the user will be
            subsequently informed by Housing Anywhere of the blocking
            immediately, and then be given the opportunity to comment and take
            remedial action. The right to block a user exists if:
            <ul>
              <li>
                the user has provided incorrect contact information in his/her
                user account, in particular an incorrect or invalid email
                address;
              </li>
              <li>a user account is transferred to another party;</li>
              <li>
                the user significantly harms other users, in particular if their
                accommodations and/or furnishings are damaged, destroyed,
                stolen, etc.;
              </li>
              <li>
                there is just cause due to similar risk and responsibility of
                the user.
              </li>
            </ul>
          </li>
          <li>
            After a user has been permanently blocked by Housing Anywhere, he is
            not entitled to have the blocked user account restored. The user
            will also no longer be permitted to use the website with other user
            accounts or to re-register.
          </li>
          <li>
            User is liable to any damages incurred by Housing Anywhere that
            follow from a violation of these terms&conditions. Housing Anywhere
            can recover its damages caused within the context of these
            terms&conditions against user. Futhermore, user safeguards Housing
            Anywhere from any third party claims in connection with user&apos;s
            infringement of the terms&conditions.
          </li>
        </ol>
        <h4>Article 12: Conversations via Housing Anywhere</h4>
        <ol>
          <li>
            We collect data from conversation happening on our messaging
            platform via the inbox window of HousingAnywhere website. One of the
            main reason for collecting data is Fraud prevention and security of
            our users. To know more information about how and why we collect
            this data please consult our Privacy policy.
          </li>
          <li>
            Any other information Housing Anywhere collects, uses and retains
            through the website will be used and stored in compliance with
            appropriate laws and regulations.
          </li>
          <li>
            In the case of a dispute between tenant and provider Housing
            Anywhere can provide both parties with the chat history upon
            request.
          </li>
        </ol>
        <h4>Article 13: Housing Anywhere’s liability</h4>
        <ol>
          <li>
            Housing Anywhere is fully liable for damages caused with intent or
            through gross negligence by Housing Anywhere, its employees or
            agents, for fraudulent concealment of defects and if a guarantee was
            expressly assumed.
          </li>
          <li>
            Housing Anywhere is liable for other damages only if they arise from
            violation of a duty whose fulfillment makes the proper
            implementation of the agreement possible and compliance with which
            it is regularly trusted by the parties to the agreement. Its duty to
            pay compensation is limited to such damages that are considered
            typical for the agreement and foreseeable.
          </li>
          <li>
            As Housing Anywhere does not participate in the contractual
            relationship between the tenant and the provider, Housing Anywhere
            accepts no liability for contracts for accommodation.
          </li>
          <li>
            Housing Anywhere offers the option of contacting Housing Anywhere
            with a complaint if there are any problems with regards to the
            website, accommodation or provider. The complaint must be provided
            in written form (e-mail). In this complaint the guest must
            specifically indicate the grounds for the complaint. In such a case
            Housing Anywhere will attempt to bring about a solution.
          </li>
        </ol>
        <h4>Article 14: Cancellation of a booking - penalty</h4>
        <ol>
          <li>
            For tenants and advertisers who want to cancel the booking within
            the following 24 hours of which the original booking was
            implemented:
            <ul>
              <li>there will be no penalty for advertisers</li>
              <li>
                tenants are guaranteed their money back for the first month’s
                rent
              </li>
            </ul>
          </li>
          <li>
            The refund guarantee for tenants under 1 is exclusive of the booking
            fee, unless the room:
            <ul>
              <li>was double booked</li>
              <li>is not available</li>
            </ul>
          </li>
          <li>
            Tenants refund guarantee - under the restriction mentioned under 2 -
            will be refunded as soon as possible, but no later than 30 days
            after repealing the booking.
          </li>
          <li>
            Cancellation should take place exclusively by letter or email.
          </li>
          <li>
            Cancellation of a the booking after the day of booking, entails that
            a penalty will be charged.
          </li>
          <li>
            If an advertiser cancels a booking after the day of booking due to
            mistaken room availability or personal preference of a tenant, they
            will be subject to a multi-stage penalty:
            <ul>
              <li>
                stage 1: After 1st cancellation, advertiser’s listing will be
                moved to the end of the list on the search page of the relevant
                city for a period of 2 weeks;
              </li>
              <li>
                stage 2: With repeated cancellations, stage 1 penalty will be
                executed again and 10%% of the month’s rent for the next booking
                will be held back by HousingAnywhere as a penalty fee.
              </li>
            </ul>
          </li>
          <li>
            If a tenant cancels a booking after the day of the booking due to
            added price, the multi-stage penalty will also apply
          </li>
          <li>
            If a tenant cancels a booking after the day of booking due to
            reasons in the absence of force majeure, Housing Anywhere will
            withhold the booking fee as compensation for their services.
          </li>
          <li>
            The advertiser of tenant will be informed in writing or by email,
            when a penalty will be charged.
          </li>
        </ol>
        <h4>Article 15: Advise for users</h4>
        <ol>
          <li>
            Housing Anywhere advises users to enter into a contractual agreement
            with each other. As stated before HousingAnyshere.com is not part in
            the agreement between provider and tenant and therefore advises both
            parties to enter into a contractual agreement with each other.
            Housing Anywhere offers a draft agreement on its website but does
            not guarantee the completeness of this contract.
          </li>
          <li>
            Housing Anywhere furthermore advises the tenant to obtain liability
            insurance to cover for costs in case damages to the accommodation
            arise.
          </li>
        </ol>
        <h4>Article 16: Closing provisions</h4>
        <ol>
          <li>
            Housing Anywhere is authorised to transfer its rights and
            obligations under this agreement in full or in part to third
            parties.
          </li>
          <li>
            Housing Anywhere is authorised to send mailings to its users about
            sidejobs, jobs and internships at Housing Anywhere to its users
            through a newsletter. Users will have the possibility to unsubscribe
            from this newsletter.
          </li>
          <li>
            This agreement is subject solely to the substantive laws of the
            Kingdom of The Netherlands with the exception of the UN Convention
            on the International Sale of Goods and Dutch international private
            law.
          </li>
          <li>
            If the user is a consumer within the meaning of Book 7 of the
            Burgerlijk Wetboek (BW – Dutch Civil Code), this does not affect the
            mandatory consumer protection regulations in which the consumer is
            ordinarily resident.
          </li>
          <li>
            If individual provisions of these General Terms and Conditions are
            or become wholly or partially invalid, the other General Terms and
            Conditions are still valid. In the event of such a provision being
            invalid, it shall be replaced by a legal provision.
          </li>
          <li>
            All declarations to be sent in connection with the user agreement to
            be concluded with Housing Anywhere must be issued by email. The
            postal address and email address of a user are those that are stated
            as the current contact data in the user’s user account.
          </li>
          <li>
            These terms and conditions will be interpreted in accordance with
            the Dutch law. You and Housing Anywhere agree to submit to the
            jurisdiction of the court located in Rotterdam, The Netherlands for
            any actions of which parties seek injunctive or other equitable
            relief in a court of competent jurisdiction.
          </li>
        </ol>
      </li>
    </ul>
  );
}

export default Terms;
